import { render, staticRenderFns } from "./MemoCrud.vue?vue&type=template&id=b432cbf8"
import script from "./MemoCrud.vue?vue&type=script&lang=js"
export * from "./MemoCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports